// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationAddPage_wrapper__-f8qe"};